import "../css/displaycard.css";


export const DisplayCard = ({ class_,value, label, image,onClick='',active=true  }) => {
    return(
        <div className={`display-card ${class_}`} onClick={onClick}>
            <div className="display-card-content">
                <span className={`display-card-value ${!active?"inactiveText":''}`}>{value}</span>
                <span className={`display-card-label ${!active?"inactiveText":''}`}>{label}</span>
            </div>
            {image && <img src={image} alt="card background" className="display-card-image" />}
        </div>
    )
}

export const DisplayCardInactive = ({ class_,value, label, image,onClick='' }) => {
    return(
        <div className={`display-card ${class_}`} onClick={onClick}>
            <div className="display-card-content">
                <span className="display-card-value inactiveText">{value}</span>
                <span className="display-card-label inactiveText">{label}</span>
            </div>
            {image && <img src={image} alt="card background" className="display-card-image" />}
        </div>
    )
}
